import { mapKeys, camelCase } from 'lodash'
import { ActionTree } from 'vuex'
import { ProfileState } from './types'
import { RootState } from '@/store/types'
import { Http } from '@/api'

export const actions: ActionTree<ProfileState, RootState> = {
  login: ({ commit }, { username, password }) => {
    return Http.post('account/login', { username, password })
      .then(
        (data: any) => {
          // Convert all keys to camel case
          const user = mapKeys(data, (_, k) => camelCase(k))
          commit('storeUser', { user })
          commit('loginSuccess', { user })
          return true
        },
      )
      .catch(() => {
        commit('loginError')
        return false
      })
  },
  logout: ({ commit }) => {
    return Http.post('account/logout')
      .then(
        () => {
          commit('clearUser')
          commit('logout')
        }
      )
  },
  loadUser: ({ commit, getters }) => {
    const user = getters.retrieveUser
    commit('loginSuccess', { user })
  }
}
